import { util } from 'pevueglobal'
import { router } from '../../router'
import { store } from '@/store/'
import { XVtableGetRowStateProperty, XVtableGetValue, setXVtableMutations } from '../XVtableV2'

// state
const state = {
  ddLoaded: false,
  personRolesTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  myAdminsInstitutes: [],
  mentors: [],
  mentorSearch: '',
  dlSelected: '',
  toggleDateRow: []
}

// getters
const getters = {
  ddLoaded: state => state.ddLoaded,
  toggleDateRow: state => state.toggleDateRow,
  toggleDateRowSelected: state => selmentor => state.toggleDateRow.filter(mentor => mentor === selmentor).length !== 0, // id in toggledatarow?
  dlSelected: state => state.dlSelected,
  mentorSearch: state => state.mentorSearch,
  personRolesTable: state => state.personRolesTable,
  XVtableGetRowStateProperty: XVtableGetRowStateProperty('personRolesTable'),
  XVtableGetValue: XVtableGetValue('personRolesTable'),
  myAdminsInstitutes: state => {
    let dlInstitutes = state.myAdminsInstitutes.map(institute => ({
      value: institute.tblExternalOrganizationID,
      labelText: institute.tblExternalOrganizationName
    }))
    return dlInstitutes
  },
  filteredMentors: state =>
    state.mentors.map(mentor => {
      mentor.visible = mentor.tblPersonName.toLowerCase().indexOf(state.mentorSearch.toLowerCase()) >= 0
      return mentor
    })
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      17,
      23,
      150,
      177,
      4923,
      4993,
      5021,
      5022,
      5023,
      5024,
      5025,
      5026,
      5027,
      5029,
      5030,
      5031,
      5040,
      5494,
      11911,
      11986,
      12980,
      14589,
      14642,
      14702,
      14764
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },
  getPersonRoles: async ({ commit, rootState }) => {
    const tabledata = await util.GetXVTableDataV2('prof/PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable')
    if (tabledata != null) {
      commit('setPersonRolesTableData', tabledata)
      commit('setXVtableColumnsettings')
      commit('setXVtablesetting')
      commit('initXVtableState', state.personRolesTable)
    }
  },
  getInstitutes: async ({ commit, state, dispatch }) => {
    state.ddLoaded = false

    const myAdminsInstitutes = await util.getDataApi('prof/PEapi_SPE671_PR_ExtOrg_MyAdmins_Instituuts')

    if (myAdminsInstitutes.ds.data0.length === 1) {
      dispatch('getMentor', {
        SelectedInstituutID: myAdminsInstitutes.ds.data0[0].tblExternalOrganizationID
      })
    }
    commit('setMyadminsInstitutes', myAdminsInstitutes)
  },
  getMentor: async ({ commit }, MentorInput) => {
    const myAdminsMentorSelect = await util.getDataApi('prof/PEapi_SPE671_PR_ExtOrg_MyAdmins_MentorSelect', MentorInput)
    commit('setMyadminsMentorSelect', myAdminsMentorSelect)
  },
  setMentor: async ({ rootState, commit }, MentorInput) => {
    const output = await util.getDataApi('prof/PEapi_TblExternalOrganizationAdministratorProf_insert', MentorInput)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      router.push({ name: 'Spe671PrExtOrgMyAdmins', params: { MentorAdded: true } })
    }
  },
  updateDate: async ({ commit, rootState }, MentorInput) => {
    const output = await util.getDataApi('prof/PEapi_TblExternalOrganizationAdministratorProf_update', MentorInput)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      commit('updateDate', MentorInput)
    }
  },
  deleteMentor: async ({ commit, rootState }, mentorID) => {
    const output = await util.getDataApi('prof/PEapi_TblExternalOrganizationAdministratorProf_delete', {
      TblExternalOrganizationAdministratorID: mentorID
    })
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      commit('deleteMentor', mentorID)
    }
  }
}

// mutations
const mutations = {
  ...setXVtableMutations('personRolesTable'),
  toggleDateRowByID(state, mentor) {
    if (state.toggleDateRow.indexOf(mentor) === -1) {
      state.toggleDateRow.push(mentor)
    } else {
      mentor.mentorDatum = null
      state.toggleDateRow.splice(state.toggleDateRow.indexOf(mentor), 1)
    }
  },
  setToggleDateRow(state, value) {
    state.toggleDateRow = value
  },
  setdlSelected(state, value) {
    state.toggleDateRow = []
    state.dlSelected = value
  },
  setmentorSearch(state, value) {
    state.mentorSearch = value
  },
  setMyadminsInstitutes(state, myAdminsInstitutes) {
    state.dlSelected = ''
    state.myAdminsInstitutes = myAdminsInstitutes.ds.data0
  },
  setMyadminsMentorSelect(state, myAdminsMentorSelect) {
    let reduceMentors = []
    myAdminsMentorSelect.ds.data0.forEach(mentorRow => {
      let mentorFilter = reduceMentors.filter(function(mentor) {
        return mentorRow.adminPersonID === mentor.adminPersonID
      })
      // als mentorFilter leeg is, dan komt mentor nog niet voor in reduce mentor
      if (mentorFilter.length === 0) {
        mentorRow.roles = []
        mentorRow.roles.push(mentorRow.role)
        reduceMentors.push(mentorRow)
      } else {
        mentorFilter[0].roles.push(mentorRow.role)
      }

      mentorRow.mentorDatum = null
      return mentorRow
    })
    if (reduceMentors.length === 1) {
      state.toggleDateRow.push(reduceMentors[0])
    }
    state.mentors = reduceMentors

    state.ddLoaded = true
  },
  deleteMentor(state, mentorID) {
    state.personRolesTable.tabledata = state.personRolesTable.tabledata.filter(
      rij => rij.tblExternalOrganizationAdministratorID !== mentorID
    )
  },
  updateDate(state, MentorInput) {
    state.personRolesTable.tabledata.forEach((datarow, i) => {
      if (datarow.tblExternalOrganizationAdministratorID === MentorInput.DateUpToAndAdminID[0].intvalue) {
        state.personRolesTable.tabledata[i].tblExternalOrganizationAdministratorProfDateUpTo =
          MentorInput.DateUpToAndAdminID[0].datevalue
      }
    })
  },
  // XVTABLE INSTELLINGEN
  setPersonRolesTableData(state, data) {
    state.personRolesTable.tabledata = data.tabledata
    // om intSettingDialot te testen kan je dit aanpassen: (1, 2 of 3)
    // state.settings.intSettingDialog = 1
  },
  setXVtablesetting(state) {
    state.personRolesTable.tablesetting = {
      alwaysShowDetail: null,
      tableName: 'personRoles',
      paging: 1,
      pagingSize: 20,
      procedure: 'PEapi_SPE671_PR_EtOrg_MyAdmins_XVTable',
      sequence: 1,
      sortable: 1
    }
  },
  setXVtableColumnsettings(state) {
    state.personRolesTable.tablecolumnsetting = [
      {
        columnname: '',
        helpTextID: null,
        name: 'tblPersonWijzig',
        headerTextID: 0,
        sequence: 1,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'tblPersonVerwijder',
        headerTextID: 0,
        sequence: 2,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: store.getters.translation(5024),
        helpTextID: null,
        name: 'tblPersonName',
        headerTextID: 5024,
        sequence: 3,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 1,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: store.getters.translation(4993),
        helpTextID: null,
        name: 'tblPersonEmail',
        headerTextID: 4993,
        sequence: 4,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: store.getters.translation(5025),
        helpTextID: null,
        name: 'tblExternalOrganizationName',
        headerTextID: 5025,
        sequence: 5,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '200px',
        widthSM: null,
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: store.getters.translation(5026),
        helpTextID: null,
        name: 'tblExternalOrganizationAdministratorProfDateUpTo',
        headerTextID: 5026,
        sequence: 6,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '140px',
        widthSM: '140px',
        widthXS: '140px',
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: store.getters.translation(5027),
        helpTextID: null,
        name: 'rollen',
        headerTextID: 5027,
        sequence: 7,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      },
      {
        columnname: 'Text not defined',
        helpTextID: null,
        name: 'tblExternalOrganizationAdministratorID',
        headerTextID: null,
        sequence: 8,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'number',
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personRoles',
        procedure: 'PEapi_SPE671_PR_ExtOrg_MyAdmins_XVTable'
      }
    ]
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
